// Mock data for Hunt Global Collective clone

export const featuredProperties = [
  {
    id: '7901-windrose-ave-905',
    address: '7901 Windrose Ave #905',
    fullAddress: '7901 Windrose Avenue Unit 905, Plano, TX 75024',
    price: '$820,000',
    beds: 1,
    baths: 1,
    sqft: '1,018',
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/5719ee3b-93fe-40a5-94fc-cb63d358c5b5',
  },
  {
    id: '7901-windrose-ave-504',
    address: '7901 Windrose Ave #504',
    fullAddress: '7901 Windrose Avenue Unit 504, Plano, TX 75024',
    price: '$1,750,000',
    beds: 3,
    baths: 4,
    sqft: '2,589',
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/d9ad3109-a745-44f6-949b-5950c6018470',
  },
  {
    id: '7901-windrose-ave-1906',
    address: '7901 Windrose Ave #1906',
    fullAddress: '7901 Windrose Avenue Unit 1906, Plano, TX 75024',
    price: '$1,585,000',
    beds: 2,
    baths: 3,
    sqft: '2,002',
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/d90f72b8-f225-4298-9112-7f7870ba4f03',
  },
  {
    id: '7901-windrose-ave-1602',
    address: '7901 Windrose Ave #1602',
    fullAddress: '7901 Windrose Avenue Unit 1602, Plano, TX 75024',
    price: '$1,145,000',
    beds: 2,
    baths: 3,
    sqft: '1,540',
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/c499c8a9-1ed9-4970-8857-c7e084664a6e',
  },
  {
    id: '3707-marble-hill-road',
    address: '3707 Marble Hill Road',
    fullAddress: '3707 Marble Hill Road, Frisco, TX 75034',
    price: '$1,450,000',
    beds: null,
    baths: null,
    sqft: null,
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/7e6750f5-4055-4061-a49c-526a00a6fa1c',
  },
  {
    id: '973-pembrook-lane',
    address: '973 Pembrook Lane',
    fullAddress: '973 Pembrook Lane, Allen, TX 75013',
    price: '$1,390,000',
    beds: null,
    baths: null,
    sqft: null,
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/fa81d66d-28f1-4365-be9e-d6f4c1dceb2a',
  },
  {
    id: '126-eisenhower-ct',
    address: '126 Eisenhower Ct',
    fullAddress: '126 Eisenhower Court, Weston, TX 75009',
    price: '$1,375,000',
    beds: 6,
    baths: 5,
    sqft: '4,553',
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/51c678c8-da65-436d-91ec-f092306336dd',
  },
  {
    id: '2885-forest-hill-dr',
    address: '2885 Forest Hill Dr',
    fullAddress: '2885 Forest Hill Drive, TX 76227',
    price: '$1,200,000',
    beds: 4,
    baths: 4,
    sqft: '3,650',
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/39d5b814-22b5-49a2-980e-aabd42ba3466',
  },
  {
    id: '2165-minehampton-ln',
    address: '2165 Minehampton Ln',
    fullAddress: '2165 Minehampton Ln, Dallas, TX 75201',
    price: '$900,000',
    beds: 3,
    baths: 4,
    sqft: '2,400',
    status: 'Sold',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/cfbdb6a8-759a-4c39-9e4c-f7195a5df048',
  },
];

export const stats = [
  { value: '50', label: 'States' },
  { value: '27', label: 'Countries' },
  { value: '30+', label: 'Years of Experience' },
];

export const pressLogos = [
  { name: 'Robb Report', src: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/0205d07c-3e94-440d-824a-e73d757c7804' },
  { name: 'The Wall Street Journal', src: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/7060f170-3019-452c-863e-f9c3bf67ff6d' },
  { name: 'MarketWatch', src: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/230eb9a1-8aad-4c61-ad8a-3f4db739be0f' },
  { name: "Barron's", src: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/74d5699a-1846-48ae-83c8-44b98599c810' },
  { name: 'Unique Homes', src: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/bec227d9-4b44-42d0-acb2-c6007b87e763' },
  { name: 'Mansion Global', src: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/576ba142-1379-4ea5-9487-3ba78ff0105d' },
  { name: 'Forbes', src: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/159cbed0-5632-4314-9363-de74d58cd81d' },
  { name: 'Bloomberg', src: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/8fd4fa82-c69d-46e6-a51d-eb191301fafb' },
];

export const collectiveTiers = [
  {
    id: 'launch',
    title: 'Launch',
    description: 'A high-integrity foundation for advisors entering luxury with clarity, confidence, and elevated identity.',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/917f2842-c106-450c-bfb0-d8b0edbe8ae4',
  },
  {
    id: 'prestige',
    title: 'Prestige',
    description: 'Refined positioning and influence for established advisors expanding presence, brand equity, and market reach.',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/144baa6d-cbaa-47d4-ad5c-50e6982d829d',
  },
  {
    id: 'legacy',
    title: 'Legacy',
    description: 'Equity, wealth, and multi-tier expansion beyond production \u2014 for advisors building generational impact.',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85/https://media-production.lp-cdn.com/media/ad223d01-e117-4e13-a359-20fa7d75e91b',
  },
];

export const heroImage = '/assets/hero-poster.jpg';
// Set to a video URL (mp4/webm) to play a background video. Leave as null to use heroImage.
export const heroVideo = '/assets/hero.mp4';

// About page — Executive Leadership
export const leadership = [
  {
    name: 'Daniel Hunt Jr.',
    role: 'Founder',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/5d0bc8a5-8aad-4c56-a318-4d660f8894a7',
    email: 'daniel.r.hunt@exprealty.com',
    mobile: '(214) 280-1926',
    address: '15950 Dallas Pkwy, Suite 400, Dallas, TX 75248',
    bio: [
      'Daniel Hunt Jr. leads with a vision shaped by legacy, faith, and service. A modern voice in luxury real estate, he merges cinematic storytelling, strategic brand-building, and elevated advisory to create experiences defined by trust, depth, and meaningful connection. His blend of creativity and disciplined execution has positioned him as a respected leader in today\u2019s luxury landscape.',
      'With nearly a decade in luxury real estate\u2014supported by earlier experience in lending, underwriting, and investment\u2014Daniel brings a rare multidisciplinary perspective that offers clarity and confidence to both clients and advisors. His influential online presence, including a globally followed YouTube channel, showcases cinematic property films and lifestyle storytelling that attract discerning buyers from around the world.',
      'Beyond real estate, Daniel is a dynamic speaker whose faith-driven message centers on discipline, belief, and the conviction that excellence expands when shared. His strategic frameworks and personal journey continue to inspire audiences nationwide.',
      'As the founder of Hunt Global Collective, Daniel envisioned more than an organization\u2014he envisioned a movement grounded in purpose, collaboration, and elevated identity. Through mentorship, aligned partnerships, and refined brand strategy, he empowers advisors to build businesses defined by mastery, integrity, and meaningful impact.',
      'Daniel\u2019s commitment to service extends beyond the industry. He remains deeply involved in philanthropic initiatives, including youth mentorship and outreach supporting individuals experiencing homelessness. His dedication to people\u2014clients, advisors, and communities alike\u2014is the heart of his leadership.',
      'Choosing to work with Daniel Hunt Jr. means entering an experience shaped by sophistication, transparency, and genuine care. Whether serving luxury clientele, guiding advisors, or advancing the vision of Hunt Global Collective, Daniel remains anchored in the values that define his life: faith, family, legacy, and a relentless pursuit of excellence.',
    ],
  },
  {
    name: 'Alacyn Wolfe',
    role: 'Chief Growth Officer',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_collective-hub-15/artifacts/absrie0c_B04575A1-4586-42A1-9887-67591B45F57B.PNG',
    email: 'alacyn.wolfe@exprealty.com',
    mobile: '(619) 713-3535',
    address: '15950 Dallas Pkwy, Suite 400, Dallas, TX 75248',
    bio: [
      'As Chief Growth Officer of Hunt Global Collective, Alacyn helps shape the organization\u2019s vision, commercial strategy, and long-term growth. Since the Collective\u2019s inception, she has played an integral role in building its brand identity, expanding its market presence, cultivating strategic partnerships, and developing the infrastructure designed to support its continued evolution.',
      'For more than 15 years, Alacyn has worked at the intersection of luxury real estate, executive leadership, business development, brand strategy, and client experience. Throughout her career, she has represented premium brands, served affluent clientele, and worked alongside leadership teams to identify opportunities, strengthen market positioning, and guide high-value decisions with professionalism and discretion.',
      'Her approach is grounded in a simple philosophy: luxury is not defined by price\u2014it is defined by the experience. As Chief Growth Officer, she brings that philosophy to the commercial side of the business\u2014leading expansion, developing strategic relationships, and creating scalable opportunities for growth while preserving the identity and standards that distinguish the Collective.',
      'Committed to the principles of quiet luxury, Alacyn believes the strongest organizations do more than grow\u2014they build lasting value. For her, leadership is measured by what is built, who it elevates, and the legacy it leaves behind.',
    ],
  },
  {
    name: 'Daniel Montemayor',
    role: 'Director of International Markets',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/1af39110-d2f7-4120-bf54-52fd383e38dc',
    email: 'daniel.montemayor@exprealty.com',
    mobile: '(214) 926-4755',
    address: '15950 Dallas Pkwy, Suite 400, Dallas, TX 75248',
    bio: [
      'Daniel brings global perspective, cultural fluency, and refined advisory to the luxury space, serving as a bridge between domestic and international markets. As a Global Real Estate Advisor, his background spans international leadership, cross-cultural communication, and immersive market development\u2014equipping him to guide clients and Collective advisors with confidence across diverse environments. With experience navigating both Latin and worldwide markets, he supports advisors serving international clientele with precision and elevated service.',
      'Guided by authenticity and a modern understanding of global luxury, Daniel cultivates meaningful relationships across borders rooted in trust, sophistication, and depth of connection. He believes true international representation requires cultural nuance, integrity, and human understanding\u2014principles he models and teaches throughout the Collective. His leadership strengthens the Collective\u2019s global presence and empowers advisors to thrive within the world\u2019s most dynamic and discerning markets.',
    ],
  },
  {
    name: 'Tommy Wooten',
    role: 'Director of Community Impact',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/1fdd16bf-65b5-47e3-b535-3951200e9d23',
    email: 'tommy.wooten@exprealty.com',
    mobile: '(972) 746-9360',
    address: '15950 Dallas Pkwy, Suite 400, Dallas, TX 75248',
    bio: [
      'With more than fifteen years in real estate\u2014including recognition as MetroTex real estate professional of the Year\u2014Tommy brings depth, heart, and community-rooted leadership to Hunt Global Collective. As a trusted advisor, he anchors culture in values, service, and authentic relationship, guiding both clients and Collective advisors to build influence that extends far beyond production. His extensive background in civic engagement and relationship-driven business development provides a grounding presence within the organization and reinforces the Collective\u2019s commitment to people-first leadership.',
      'Tommy empowers advisors to strengthen their presence through philanthropy, community connection, and intentional service. He believes legacy is built through contribution, and that true luxury advisory includes elevating both people and place. His guidance ensures every advisor not only builds a thriving business, but also creates a lasting impact\u2014one defined by integrity, compassion, and meaningful cultural contribution.',
    ],
  },
  {
    name: 'Skyler McKinley',
    role: 'Director of New Agent Success',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/8e39aec8-a1d4-4075-b2a3-db02097d057c',
    email: 'skyler.mckinley@exprealty.com',
    mobile: '(214) 952-6921',
    address: '15950 Dallas Pkwy, Suite 400, Dallas, TX 75248',
    bio: [
      'With more than twelve years in real estate, Skyler brings deep industry knowledge, leadership recognition, and a calm, confidence-building presence to luxury advisory\u2019s next generation. As a trusted advisor within the Collective, she is known for her professionalism, service, and meaningful influence\u2014earning distinctions such as TRLP graduate, MetroTex 40 Under 40 honoree, and former YPN Chair. Her experience equips her to guide new professionals with clarity, structure, and refined preparation, ensuring they begin their careers from a place of strength and intention.',
      'Skyler leads New Agent Success with an education-first philosophy and a deep commitment to disciplined growth. She creates systems that support learning, skill development, and early momentum, helping advisors build both confidence and capability. Her mentor-driven approach blends thoughtful guidance with elevated standards\u2014ensuring every new Collective advisor steps into their business with purpose, professionalism, and the foundational habits required for long-term mastery.',
    ],
  },
  {
    name: 'Luke Jones',
    role: 'Director of Advisor Expansion',
    image: 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/a3043985-73d0-4e7a-bfb1-3eb85f975748',
    email: 'luther.jones@exprealty.com',
    mobile: '(305) 747-9311',
    address: '15950 Dallas Pkwy, Suite 400, Dallas, TX 75248',
    bio: [
      'With more than a decade of real estate experience\u2014including ownership of a successful brokerage\u2014Luke brings strategic vision, operational depth, and a refined understanding of advisor growth. As an advisor within the Collective, he blends disciplined structure with modern leadership, helping professionals strengthen identity, build meaningful authority, and position themselves confidently within the luxury space. His background in organizational scaling and brand influence positions him as a pivotal force in guiding Collective advisors toward elevated alignment and long-term growth.',
      'Luke leads Advisor Expansion with clarity, intention, and a genuine commitment to empowering others. He supports advisors in developing strategic partnerships, expanding their reach, and building businesses grounded in sophistication and integrity. His leadership ensures the Collective continues to grow with excellence\u2014cultivating environments where every advisor evolves with purpose, confidence, and a clearly defined professional presence.',
    ],
  },
];

// Prestige page images
export const prestigeHeroImage = 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/6b741cd7-bcf0-4e56-b5bf-74861a53fdc4';
export const prestigeExperienceImage = 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/01dc3ebe-da36-4d26-a936-07e9bdb495d2';
export const prestigeLegacyImage = 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/3813a0f6-ab35-4272-9b74-f3e57c871d47';

// Legacy page images
export const legacyHeroImage = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_collective-hub-15/artifacts/ktioerba_471C719A-7E91-4EFA-A6C4-261510A94FF2.PNG';
export const legacyFutureImage = 'https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/8c8279c6-e1f8-426e-91ec-5e9614affa4c';
export const artOfRepImage = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_collective-hub-15/artifacts/zaol9hpp_IMG_2704.jpg';
export const principalsImage = 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80';
export const luxuryDivisionImage = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_collective-hub-15/artifacts/qjhg68te_61FAD6B6-31A5-45BC-BEA6-6AB559A6D679.PNG';
export const sportsEntImage = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_collective-hub-15/artifacts/ia6if10o_1BC4D888-0092-4FAC-9ECB-06AE082CC3EC.PNG';
export const globalBenchmarkImage = 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80';
